import {SET_ADMIN_PAGE} from "../constants/actionTypes";

export const setAdminPage = page => {
  return dispatch => {
    dispatch({type:SET_ADMIN_PAGE,page});
  };
};
